import React from 'react';
import { usePage } from '../contexts/pageContext';
import { useTranslate } from '../contexts/languageContext';
import styled from 'styled-components/macro';
import { useNomenclator } from '../contexts/nomenclatorContext';
import LayoutResultados from '../components/LayoutResultados';
import InfoGeneral from '../containers/InfoGeneral';
import FooterLayout from '../components/Footer/Footer';
import { responsive } from '../resources/constantes.json';

const ResultadosInfoGeneral = () => {
  const pageState = usePage();
  const t = useTranslate();
  const { data, urlInfo } = pageState;

  return (
    <MainContainer>
      <InfoGeneral />
      <FooterLayout estadisticas />
    </MainContainer>
  );
};

const MainContainer = styled.div`
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 16px;
  flex-direction: column;
  display: flex;
  min-height: calc(100vh - 212px);
  justify-content: space-between;
  @media screen and (max-width: ${responsive.mobile}px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export default ResultadosInfoGeneral;
